import React from 'react'
import { isNull } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { Box, Callout } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ProofOfPaymentButton } from 'components/ProofOfPaymentButton/ProofOfPaymentButton'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { TransactionType, TTransactionSubType } from 'types/transaction/TransactionType'
import { getSupportedPaymentTypes, getTransactionStatus } from 'utils/utils'

interface ProofOfPaymentContainerProps {
  transactionType?: string
  transactionSubType?: TTransactionSubType | string
  status?: string
  externalReference?: string
  hasProofOfPayment?: boolean
  isLink?: boolean
  paymentReference?: string
}

export const ProofOfPaymentContainer = ({
  transactionType,
  transactionSubType,
  status,
  externalReference,
  hasProofOfPayment,
  isLink = false,
  paymentReference,
}: ProofOfPaymentContainerProps) => {
  const { t } = useTranslation()
  const { profile } = useProfileContext()
  const { emailAddress } = profile || {}

  const cryptoWithdrawalSubType = getSupportedPaymentTypes().CRYPTO_WITHDRAWAL

  const failedStatuses = getTransactionStatus()?.failedStatuses
  const pendingStatuses = getTransactionStatus()?.pendingStatuses

  const isFailedTransaction = failedStatuses?.includes(status)

  const isFiatWithdrawal =
    transactionType === TransactionType.USER_WITHDRAWAL &&
    transactionSubType !== cryptoWithdrawalSubType

  const popReference = paymentReference || ''

  let calloutText

  const popRequest = `${process.env.POP_REQUEST_URL}?ticket_form_id=9628604216594&tf_anonymous_requester_email=${emailAddress}&tf_subject=POP Request - Reference ${popReference}&tf_360020194739=${popReference}&tf_17483170612370=proof_of_payment_needed`

  if (isNull(hasProofOfPayment)) {
    calloutText = (
      <Box flex isFlexWrap gapX={4} testId="request-pop">
        {t('notBankingAPIWalletPart1')}
        <ExternalLink href={popRequest}>{t('clickHere')}</ExternalLink>
        {t('notBankingAPIWalletPart2')}
      </Box>
    )
  } else if (pendingStatuses?.includes(status)) {
    calloutText = t('transactionInProgress')
  }

  return (
    <Box>
      {!isFailedTransaction && isFiatWithdrawal && hasProofOfPayment && (
        <Box {...(!isLink && { paddingX: 16, paddingB: 16 })}>
          <ProofOfPaymentButton isLink={isLink} externalReference={externalReference} />
        </Box>
      )}

      {!isFailedTransaction && isFiatWithdrawal && calloutText && (
        <Box {...(!isLink && { paddingX: 16, paddingB: 16 })}>
          <Callout variant="info">{calloutText}</Callout>
        </Box>
      )}
    </Box>
  )
}

export default ProofOfPaymentContainer
